import { connect } from 'react-redux';
import CampaignListing from "./CampaignListing";
import { bindActionCreators } from 'redux';
import { getCampaignData, createInvoiceForCampaign } from 'services/redux/brandActivtion/adsCampaign/action';

const mapStateToProps = state => ({
    getCampaignListing: state.campaignReducer.getCampaignListing,
    invoiceCreationAgainstCampaign: state.campaignReducer.invoiceCreationAgainstCampaign,
});

const mapDispatchToProps = dispatch => bindActionCreators({
    createInvoiceForCampaign,
    getCampaignData
}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(CampaignListing);
